import AuraFXPage from "@/components/AuraFXPage";

const AuraUSDJPY = () => {
  return (
    <AuraFXPage 
      instrument="USDJPY" 
      name="USD/JPY" 
      apiPath="/aura/usdjpy" 
    />
  );
};

export default AuraUSDJPY;
